import ReportingSubLinks from '../../components/header/ReportingSubLinks.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';
import QueryForm from '../../components/reporting/QueryForm.jsx';

/**
 * Component for rendering the page for Query tool.
 * @returns {JSX.Element} QueryToolPage component.
 */
const QueryToolPage = () => {
    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}>
            {/* Top Links */}
            <ReportingSubLinks />
            <div
                className="newsc-container"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    overflow: 'hidden'
                }}>
                {/* Sticky Heading */}
                <div
                    style={{
                        background: '#ffffff',
                        padding: '20px 0',
                        marginTop: '60px',
                        borderBottom: '1px solid #e5e7eb',
                        zIndex: 5
                    }}>
                    <div className="create-office-heading">
                        <BackArrow navigateTo={-1} />
                        <h2 style={{ margin: 0 }}>Query</h2>
                    </div>
                </div>

                {/* Scrollable Form Area */}
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        paddingTop: '20px'
                    }}>
                    <QueryForm />
                </div>
            </div>
        </div>
    );
};

export default QueryToolPage;
